import { InjectionToken } from '@angular/core';

export const PUBLIC_ROUTES = new InjectionToken<string[]>('__PUBLIC_ROUTES__');
